import React from 'react';
import { Flex } from '../Flex/Flex';
import { Arrow } from './Arrow';
import { AbsoluteTransformRight } from './Arrow.styled';
export function BottomArrows({
  arrowPosition,
  arrowProps
}) {
  const isSide = arrowPosition === 'side';
  const Wrapper = isSide ? AbsoluteTransformRight : Flex;
  return ['bottom', 'side'].includes(arrowPosition) ? React.createElement(Wrapper, {
    justifyContent: 'center',
    pt: isSide ? 0 : 2,
    right: 0,
    "data-testid": isSide ? 'side-right-arrow' : 'bottom-arrows'
  }, isSide ? null : React.createElement(Arrow, {
    mr: 3,
    isLeft: true,
    ...arrowProps
  }), React.createElement(Arrow, {
    ...arrowProps
  })) : null;
}